var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rol==='1')?_c('admin-view'):(_vm.rol==='2')?_c('partner-view'):(_vm.rol==='3')?_c('company-view'):(_vm.rol==='4')?_c('student-view'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }